import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../../app/service/login/login.service';

@Component({
  selector: 'home',
  templateUrl: './home.html'
})

export class HomePage {
  constructor(private loginService: LoginService, private router: Router){
    const profile:string=this.loginService.getVariableSesion("profile");
    if(profile === 'Pagos'){
      this.router.navigate(['/proveedores/proveedores-lista-banco']);
    }else if (profile !== 'Contraloría'){ 
      this.router.navigate(['/proveedores']);
    }else{
      this.router.navigate(['/aprobaciones']);
    }
  }
}
